export default "__VITE_ASSET__B2jbsmH1__"